module.exports = __webpack_public_path__ + "static/media/hipAdbuction.fcc809ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/fppExercises/hipAdbuction.png
// module id = 2544
// module chunks = 0